/* eslint-disable unicorn/filename-case */
import { Emitter } from "strict-event-emitter";
export class ToastManager {
    state = [];
    _emitter;
    _options;
    constructor(options) {
        this._emitter = new Emitter();
        this._options = {
            defaultLifetime: options.defaultLifetime ?? 5000,
        };
        // Don't warn about potential memory leaks until register at least 30
        // listeners.
        this._emitter.setMaxListeners(30);
    }
    subscribe(eventName, callback) {
        this._emitter.on(eventName, callback);
        return () => this._emitter.off(eventName, callback);
    }
    toast(props) {
        // A good length of time to keep messages up is 5 seconds plus 1 extra
        // second for every 120 words, rounding up. This is how fast the average
        // American reads. That means the shortest default that should be used as a
        // best practice is 6 seconds.
        const numberWords = props.heading.split(" ").length + props.body.split(" ").length;
        const lifetime = props.lifetime ??
            this._options.defaultLifetime + Math.ceil(numberWords / 5);
        const toastId = Date.now();
        const timeoutId = setTimeout(() => {
            this.clearToast(toastId);
        }, lifetime);
        this.state = [
            ...this.state,
            { ...props, id: toastId, timeoutId, lifetime },
        ];
        this._emitter.emit("change", this.state);
        return toastId;
    }
    clearToast(toastId) {
        const index = this.state.findIndex((toast) => toast.id === toastId);
        if (index === -1) {
            return;
        }
        const toast = this.state[index];
        clearTimeout(toast.timeoutId);
        this.state = this.state.filter((toast) => toast.id !== toastId);
        this._emitter.emit("change", this.state);
    }
    setToastLifetime(toastId, lifetime) {
        const index = this.state.findIndex((toast) => toast.id === toastId);
        if (index === -1) {
            return;
        }
        const toast = this.state[index];
        clearTimeout(toast.timeoutId);
        const timeoutId = setTimeout(() => {
            this.clearToast(toastId);
        }, lifetime);
        toast.timeoutId = timeoutId;
        // NB: Not emitting change here, since we don't really need to re-render as
        // the only thing that changed was the lifetime of a specific toast.
    }
}
//# sourceMappingURL=ToastManager.js.map